<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
		<path d="M1 0a1 1 0 00-1 1v22a1 1 0 001 1h5a1 1 0 001-1V1a1 1 0 00-1-1zM23 0h-5a1 1 0 00-1 1v22a1 1 0 001 1h5a1 1 0 001-1V1a1 1 0 00-1-1zM8.5 1v22a1 1 0 001 1h5a1 1 0 001-1V1a1 1 0 00-1-1h-5a1 1 0 00-1 1z"/>
	</svg>
</template>